
<!-- 
  @componentName：注册页面
  @author： 
  @date: 2020-11-30 15:56
  @params：
  @event：
  @note：
-->
<template>
    <passwordLoginVue v-if="loginType" ref="passData"></passwordLoginVue>
    <phoneEmailVue v-else class="register_box"  :isEmail="false" ref="fromDate" :Toast="Toast"> 
    </phoneEmailVue>
    <div class="register_btn"  >
     <van-button class="register_btn" color="#F76900" round type="primary"  :disabled="loading" @click="submitFn"  :loading="loading">Login</van-button>
    </div>
    <!-- 目前没有验证码登录的接口 暂时隐藏 -->
    <!-- <div class="login_type"  @click="isPassworderFn">{{loginType?'Login via SMS':'Login via password'}}</div> -->
    <div class="position_bottom">
    <van-divider class="or_box">Or Connect With</van-divider>
    <div class="facebook_box">
      <img v-if="!isByteApp" :src="'https://image.kilimall.com/kenya/new_wap/share/facebook_icon.png'.webpFilters()
" alt=""  @click="facebookLogin">
      <img v-if="!isByteApp" :src="'https://image.kilimall.com/kenya/new_wap/share/google.png'.webpFilters()
" alt=""  @click="googleLogin">
      <p>New to Kilimall? <span @click="goRegisterFn">Register</span></p>
        <p>By clicking this button, I agree with the <span class="span_link" @click="goPriFn">Terms and Conditions and Privacy Policies.</span></p>
    </div>
    </div>
</template>

<script>
import { reactive, ref,inject,onMounted, getCurrentInstance } from 'vue'
import { useRoute,useRouter } from 'vue-router'
// import {Toast} from 'vant'
import phoneEmail from '../../components/email-phone/index.vue'
import passwordLogin from '../../components/login/passwordLogin.vue'
import {loginFn,CommonLogin} from '../../hooks/index'


export default { 
  components:{
    phoneEmailVue:phoneEmail,
    passwordLoginVue:passwordLogin
  },
    
  props:{
    Toast:{
      type:Object,
      required: true,
      default:()=>{
          return {}
      }
    }
  },
 setup(props,{emit}) {
    // 是否在传音APP内
    const isByteApp = sessionStorage.getItem('source') === 'byteApp'

    const internalInstance  = getCurrentInstance()
    const Vue3GoogleOauth = inject("Vue3GoogleOauth");

    const router = useRouter()
    const route = useRoute()
    const tabActive = ref(2); 
    const $http = inject('$http')
    const $get_facebook_appId = inject('$get_facebook_appId')
    const fromDate = ref(null)  
    const passData = ref(null)  
    const loginType = ref(true)
    const loading = ref(false)
       // email phone Type切换
    const isPassworderFn = () => {
      loginType.value = !loginType.value
    }

    // 过滤文本前后不能输入空格
    const myTrim = (x) => {
      return x.replace(/^\s+|\s+$/gm,'');
    }
  
    const submitFn = async () => {
      if(loginType.value){
        if( !passData.value.username ) {
            return props.Toast("Please Input Username")
        }
        if(!passData.value.password) { 
            return props.Toast("Please Input Password")
        }
      }
      // 没有验证码登录的接口 暂时没有写逻辑代码
      //  else {
      //   if(!fromDate.value.verify.phone || !fromDate.value.verify.code ) {
      //       return Toast("Please Input Password")
      //   }
      // }
      
      loading.value = true;
        let params={
          username: myTrim(passData.value.username), 
          password: myTrim(passData.value.password)
        }
        let ret = await CommonLogin(params,$http,'login')
        loading.value = false
    }
    const goRegisterFn = () =>{
      emit('goRegisterFn',1)
    }
      let info = reactive({})
 onMounted( async()=>{       
        if (route.query.info) info = getInfo();
           facebookInit()
        window.fbAsyncInit = function () { facebookInit() }            
                      
      });
      let facebook_loading = ref(false)
    // facebook 
     const facebookInit =  () => {
            let id = 'facebook-jssdk';
            if (!document.getElementById(id)) {
                let js, fjs = document.getElementsByTagName('script')[0];
                js = document.createElement('script');
                js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }      
            if (typeof(FB) == 'undefined') return // eslint-disable-next-line
            FB.init({ appId:$get_facebook_appId(), cookie: true, xfbml: true, version: 'v3.2' })
            // FB.getLoginStatus(ret => { this.facebookStatus(ret, false) })
        }
        /**
         * Google auto2.0
         */
        const  googleLogin = async () => {
          let $gAuth = internalInstance?.appContext.config.globalProperties.$gAuth
          try {
            const googleUser = await $gAuth.signIn();
            if (!googleUser) return null
            let google_login_params = {
              googleIdToken: googleUser.getAuthResponse().id_token,
              source: '3',
              sl_source: '',
              third_firstname: '',
              third_lastname: '',
              third_avatar: '',
              third_email: googleUser.getBasicProfile().getEmail(),
              google_quick: 0
            }
            login(google_login_params).then(ret => {
                // if (ret.code == 402) return this.$router.replace('/register?info=facebook') // 还未注册
            })
          } catch (error) {
            //on fail do something
            console.log(error);
            return null;
          }
        }
        /**
         * FB 登陆命令
         */
        const facebookLogin =   () =>  {
            facebook_loading.value = true;
            if (typeof(FB) == 'undefined') return // eslint-disable-next-line
            FB.login(ret => { facebookStatus(ret) }, { scope: 'public_profile,email', return_scopes: true })            
            setTimeout(() => {
               facebook_loading.value = false;  
            }, 1000);
            
        }
        /**
         * FB 登陆流程
         */
         const facebookStatus =   (ret)   => {
            if (ret.status !== 'connected') return // eslint-disable-next-line
            FB.api('/me?fields=id,first_name,last_name,name,email,gender', ret => { 
                let gender = 0
                switch (ret.gender) {
                    case 'male': gender = 1; break
                    case 'female': gender = 2; break
                }

                info = {
                    type: 'FACEBOOK',
                    id: ret.id,
                    name: ret.name,
                    email: ret.email,
                    gender: gender,
                    avatar: 'https://graph.facebook.com/' + ret.id + '/picture?width=400',
                }

                localStorage.setItem('info', JSON.stringify(info));    
                let params = {
                  facebookid: ret.id,
                  type: 1,
                  client: 'wap',
                  sl_source: '',
                  third_firstname: ret.first_name ? ret.first_name : '',
                  third_lastname: ret.last_name ? ret.last_name : '',
                  third_avatar: '',
                  third_email: ret.email,
                }           
                login(params).then(ret => {
                    // if (ret.code == 402) return this.$router.replace('/register?info=facebook') // 还未注册
                })
            })            
        }
        /**
         * 登陆逻辑
         */
        const login =  async  (para,type) => {        
            let ret = await $http.login(para)
            if (ret.code == 200) {                
                if(!ret.data.email && !ret.data.phone){
                   loginFn(ret.data,$http, 'bind');
                 }else{
                   loginFn(ret.data,$http,'');
                 }
            }else if(ret.code == 402){
                if(type=='login'){
                    props.Toast(ret.message);
                }else{
                   router.push('/findPwd?type=register') // 还未注册
                }               
            }else{
                props.Toast(ret.message);
            }
            return ret
        }
        const goPriFn = function () {
          router.push({
            name:'policy',
            params:{
              id:2126,
            }
          })
        }
    return { isByteApp, Vue3GoogleOauth, googleLogin, tabActive,loginType,myTrim, submitFn,fromDate,loading,isPassworderFn,goRegisterFn,passData,facebookLogin,goPriFn };
  },
}
function getInfo () {
            let info = localStorage.getItem('info')
            if (!info) return
             JSON.parse(info);
            return JSON.parse(info)
        }
</script>

<style lang='scss' scoped>
.register_box{
  padding: 60px 20px 30px;
  min-height: 25px;
}  
   .register_btn {
      margin: 0 auto 14px;
      width: 340px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      color: #fff;
      font-weight: 700;
      border-radius: 22px;
      text-align: center;
    }
    .login_type{
      margin-bottom: 85px;
      font-size: 14px;
      text-align: center;
      text-decoration: underline;
      color: #4494F0;
    }
    .or_box{
      margin: 0 20px 15px;
      font-size: 14px;
      color: #999;

    }
    .or_box::before,.or_box::after {
      background-color: #999;
      opacity:0.5
    }
    .facebook_box{
      text-align: center;
      
      img{
        margin-bottom: 10px;
        width: 48px;
        height: 48px;
        margin: 0 30px;
      }
      p:nth-of-type(1){
        margin-bottom: 16px;
        font-size: 14px;
        color: #999;
        span{
          color: #4494F0;
          text-decoration: underline;
        }
      }
     
       p:last-child{
        font-size: 12px;
        color: #999;
       .span_link{
          text-decoration: underline;
          color: #999;
        }
      }
    }
    .position_bottom{
      width: 100%;
      position: absolute;
      // --max_height:100vh;
      top: calc(var(--max_height) - 260px);
    }
</style>